<template>
<div class="signup-form">
  <b-form @submit.prevent="signup" v-if="show">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <h1 class="mb-3">REGISTRATI</h1>
      </div>
      <!-- <div class="col-lg-3 col-md-6 col-sm-12">
        <b-form-group label="Tipo:">
          <b-select v-model="form.type">
            <option value="client">Cliente/Fornitore</option>
            <option value="partner">Partner</option>
          </b-select>
        </b-form-group>
      </div> -->
      <div class="col-lg-3 col-md-6 col-sm-12">
        <b-form-group label="Nome *">
          <b-form-input v-model="form.name" required/>
        </b-form-group>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <b-form-group label="Cognome *">
          <b-form-input v-model="form.surname" required/>
        </b-form-group>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <b-form-group label="Nome Azienda *">
          <b-form-input v-model="form.company" required/>
        </b-form-group>
      </div>
      <div  class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group label="Indirizzo Email: *">
          <b-form-input v-model="form.email" type="email" required/>
        </b-form-group>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group @submit.stop.prevent>
          <label for="text-password">Password  *</label>
          <b-input type="password" v-model="form.password" required/>
          <!-- <b-form-text>
                Your password must be 8-20 characters long, contain letters and numbers, and must not
                contain spaces, special characters, or emoji.
              </b-form-text> -->
        </b-form-group>
      </div>



      <div class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group label="P.IVA *">
          <b-form-input v-model="form.vat_number" required/>
        </b-form-group>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group label="Telefono *">
          <b-form-input v-model="form.phone_number" required/>
        </b-form-group>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group label="Indirizzo *">
          <b-form-input v-model="form.addr_street" required/>
        </b-form-group>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group label="Città *">
          <b-form-input v-model="form.addr_city" required/>
        </b-form-group>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <b-form-group label="Provincia (Sigla) *">
          <b-form-input v-model="form.addr_prov" required/>
        </b-form-group>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <b-form-group label="Regione *">
          <b-form-select v-model="form.region" :options="region_options" required></b-form-select>
        </b-form-group>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <b-form-group label="CAP  *">
          <b-form-input v-model="form.addr_zip" required/>
        </b-form-group>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12">
        {{errors}}
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
        <b-button type="submit" size="lg" variant="primary">CONFERMA</b-button>
      </div>
    </div>
  </b-form>
</div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        type: 'partner',
      },
      show: true,
      errors: null,
      is_loading: false,
      region_selected: null,
      region_options: [
        { value: 'Abruzzo', text: 'Abruzzo'},
        { value: 'Basilicata', text: 'Basilicata'},
        { value: 'Calabria', text: 'Calabria'},
        { value: 'Campania', text: 'Campania'},
        { value: 'Emilia-Romagna', text: 'Emilia-Romagna'},
        { value: 'Friuli-Venezia Giulia', text: 'Friuli-Venezia Giulia'},
        { value: 'Lazio', text: 'Lazio'},
        { value: 'Liguria', text: 'Liguria'},
        { value: 'Lombardia', text: 'Lombardia'},
        { value: 'Marche', text: 'Marche'},
        { value: 'Molise', text: 'Molise'},
        { value: 'Piemonte', text: 'Piemonte'},
        { value: 'Puglia', text: 'Puglia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Sicilia', text: 'Sicilia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Toscana', text: 'Toscana'},
        { value: 'Trentino-Alto Adige', text: 'Trentino-Alto Adige'},
        { value: 'Umbria', text: 'Umbria'},
        { value: "Val d'aosta", text: "Val d'aosta"},
        { value: 'Veneto', text: 'Veneto'}
      ]
    }
  },
  methods: {
    signup() {
      this.errors = null
      this.is_loading = true
      this.$http.post('signup', this.form)
        .then(res => {
          this.$store.user = res.data.user
          this.$store.token = res.data.token
          this.$emit('close')
        }, err => {
          console.log(err.response)
          if (err.response && [400].includes(err.response.status)) {
            this.errors = err.response.data
          }
        }).finally(() => {
          this.is_loading = false
        })
    },
  }
}
</script>
<style media="screen" lang="scss">
.signup-form {
  padding-left:15px;
  padding-right:15px;
  padding-top:10px;
  padding-bottom:10px;
}
</style>
